import { getSchema } from '@tiptap/core';
import { Blockquote } from '@tiptap/extension-blockquote';
import { Bold } from '@tiptap/extension-bold';
import { Code } from '@tiptap/extension-code';
import { CodeBlock } from '@tiptap/extension-code-block';
import { Document } from '@tiptap/extension-document';
import { Heading } from '@tiptap/extension-heading';
import { Image } from '@tiptap/extension-image';
import { Italic } from '@tiptap/extension-italic';
import { Link } from '@tiptap/extension-link';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Strike } from '@tiptap/extension-strike';
import { Subscript } from '@tiptap/extension-subscript';
import { Superscript } from '@tiptap/extension-superscript';
import { Text } from '@tiptap/extension-text';
import { Underline } from '@tiptap/extension-underline';
import { Table } from 'Shared/prosemirror/tiptap/extensions/table';
import {
   CustomHardBreak,
   FeaturedQuote,
   SiteLink,
   WikiLink,
} from 'Shared/prosemirror/tiptap/extensions';

export const standardSchema = getSchema([
   Document,
   Paragraph,
   Text,
   Heading,
   CodeBlock,
   Blockquote,
   Image,
   Italic,
   Bold,
   Underline,
   Subscript,
   Superscript,
   Code,
   Strike,
   Link,
   WikiLink,
   SiteLink,
   Table,
   FeaturedQuote,
   CustomHardBreak,
]);
